module.exports = __webpack_public_path__ + "img/hoverBox2.eb6d7183.png";